import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { GET_GUESTS_BASE_QUERY_KEY } from './get-guests'

type AddVisitorGuestRequest = {
  clientId: string
  formData: FormData
}

const addVisitorGuest = async ({ clientId, formData }: AddVisitorGuestRequest): Promise<void> => {
  await authAPI.post(`/client/${clientId}/guest`, formData)
}

export const useAddVisitorGuest = () => {
  return useMutation({
    mutationFn: addVisitorGuest,
    onSuccess: async () => {
      await resetQueries([GET_GUESTS_BASE_QUERY_KEY])
    },
  })
}
